import { getOrgMemberCountsRequestParamsSchema, getOrgMemberCountsResponseSchema, } from '../../../../../backend/features/organizations/shared/platform-functions/types/getOrgMemberCounts';
export const getOrgMemberCountsDef = {
    name: 'getOrgMemberCounts',
    requestSchema: getOrgMemberCountsRequestParamsSchema,
    responseSchema: getOrgMemberCountsResponseSchema,
};
